import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Taxpayoutresponse = ()=>{
    const [taxpayoutresponse, setTaxpayoutresponse] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`taxpayoutresponse?page=${page}`);
            setTaxpayoutresponse(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`taxpayoutresponse/${id}`);
            setTaxpayoutresponse(taxpayoutresponse.filter((taxpayoutresponse) => taxpayoutresponse.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'Tax Payout Response'}>
            
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">TimeIn </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Transactionid </th>
                                    <th className="px-4 py-3">Billreferencenumber </th>
                                    <th className="px-4 py-3">ResultCode </th>
                                    
                                    <th className="px-4 py-3">ResultDesc </th>
                                    
                                    
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {taxpayoutresponse && taxpayoutresponse.length > 0 ? (
                                         taxpayoutresponse.map((taxpayoutresponse)=>(
                                             <tr key={taxpayoutresponse.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{taxpayoutresponse.id}</td>
                                                 <td className="px-4 py-3 text-sm">{taxpayoutresponse.time_in}</td>
                                                <td className="px-4 py-3 text-sm">{taxpayoutresponse.Amount}</td>
                                                
                                                 <td className="px-4 py-3 text-sm">{taxpayoutresponse.TransactionID}</td>
                                                  <td className="px-4 py-3 text-sm">{taxpayoutresponse.BillReferenceNumber}</td>
                                                 <td className="px-4 py-3 text-sm">{taxpayoutresponse.ResultCode}</td>
                                                  <td className="px-4 py-3 text-sm">{taxpayoutresponse.ResultDesc}</td>
                                                 
                                             </tr>
                                         ))
                                ) : (
                                            <tr>
                                                <td colSpan="8" className="text-center py-5 text-gray-500">No data to display </td>
                                            </tr>
                                         )}
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default Taxpayoutresponse;